import {
  setSession,
  clearSession,
  setPendingVerification,
  clearPendingVerification,
  setShowWelcome,
} from "../store/slices/auth/auth.slice";
import { useGoogleLoginMutation } from "../service/auth/useGoogleLoginMutation";
import { persistor, useAppDispatch } from "../store";
import { useNavigate } from "react-router-dom";
import { useGoogleInviteSignupMutation } from "../service/auth/useGoogleInviteSignupMutation";
import { useAcceptInviteMutation } from "../service/auth/useAcceptInviteMutation";
import { AuthApiResponse, LoginFormPayload } from "../types/auth";
import { useJoinUser } from "service/auth/useJoinUser";
import { InvitedSignupPayload, SignupPayload } from "types/signup";
import { showToast } from "utils/toast";
import { useUserLoginMutation } from "service/auth/useUserLoginMutation";
import { useUserSignupMutation } from "service/auth/useSignupMutation";
import { useVerifyOtpMutation } from "service/auth/useVerifyOtpMutation";
import { useResendOtpMutation } from "service/auth/useResendOtpMutation";
import { useForgotPasswordMutation } from "service/auth/useForgotPasswordMutation";
import { useResetPasswordMutation } from "service/auth/useResetPasswordMutation";


export const useAuth = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const googleLoginMutation = useGoogleLoginMutation();
  const inviteSignupMutation = useGoogleInviteSignupMutation();
  const acceptInviteMutation = useAcceptInviteMutation();
  const joinInvitedUserMutation = useJoinUser();
  const userLoginMutation = useUserLoginMutation();
  const userSignupMutation = useUserSignupMutation();
  const verifyOtpMutation = useVerifyOtpMutation();
  const resendOtpMutation = useResendOtpMutation();
  const forgotPasswordMutation = useForgotPasswordMutation();
  const resetPasswordMutation = useResetPasswordMutation();
 
  const createSession = (response: AuthApiResponse) => {
    if (!response.authToken || !response.appUserUuid) {
      showToast.error("Something went wrong. Please try again.");
      return;
    }
    const isOrgOnboarded =
      response.isOrgOnboarded === true || response.isOrgOnboarded === "true";

const orgSlug = response.orgSlug || null;
    dispatch(
      setSession({
        appUserUuid: response.appUserUuid,
        email: response.email,
        firstName: response.firstName,
        lastName: response.lastName,
        orgUuid: response.orgUuid === "NULL" ? null : response.orgUuid,
        orgSlug: response.orgSlug || null,
        isOrgOnboarded,
        roleList: response.roleList,
        authToken: response.authToken,
    profileImageURL: response.profileImageURL ?? null
      }),
    );

  dispatch(setShowWelcome());
  //    navigate(
  //   isOrgOnboarded
  //     ? `/${orgSlug}/onboarding-success`
  //     : "/organization-account-setup",
  //   { replace: true }
  // );
  };

  const loginWithGoogle = async (code: string) => {
    const { response } = await googleLoginMutation.mutateAsync(code);
    if (!response?.status) {
      showToast.error(response?.message ?? "Invalid Password or Email");
      navigate("/login", { replace: true });
      return;
    }
    if (!response.isOrgOnboarded && !response.orgUuid) {
      dispatch(
        setPendingVerification({
          appUserUuid: response.appUserUuid,
          email: response.email,
          provider: "google",
        }),
      );
    }

    const isOrgOnboarded =
      response.isOrgOnboarded === true || response.isOrgOnboarded === "true";
const orgSlug = response.orgSlug || null;
    dispatch(
      setSession({
        appUserUuid: response.appUserUuid,
        email: response.email,
        firstName: response.firstName,
        lastName: response.lastName,
        orgUuid: response.orgUuid === "NULL" ? null : response.orgUuid,
        orgSlug: response.orgSlug || null,
        isOrgOnboarded,
        roleList: response.roleList,
        authToken: response.authToken,
        profileImageURL: response.profileImageURL ?? null
      }),
    );
  dispatch(setShowWelcome());
  //   navigate(
  //   isOrgOnboarded
  //     ? `/${orgSlug}/onboarding-success`
  //     : "/organization-account-setup",
  //   { replace: true }
  // );
  };

  const userLogin = async (payload: LoginFormPayload) => {
    const response = await userLoginMutation.mutateAsync(payload);

    if (!response?.status) {
  
      showToast.error(response?.message ?? "Invalid Password or Email");
      // navigate("/login", { replace: true });
      // return;
      throw new Error(response?.message ?? "Invalid credentials")
    }

    const isOrgOnboarded =
      response.isOrgOnboarded === true || response.isOrgOnboarded === "true";
   const orgSlug = response.orgSlug || null;
    dispatch(
      setSession({
        appUserUuid: response.appUserUuid,
        email: response.email,
        firstName: response.firstName,
        lastName: response.lastName,
        orgUuid: response.orgUuid === "NULL" ? null : response.orgUuid,
        orgSlug: response.orgSlug || null,
        isOrgOnboarded,
        roleList: response.roleList,
        authToken: response.authToken,
      }),
    );
    dispatch(setShowWelcome());
  //  navigate(
  //   isOrgOnboarded
  //     ? `/${orgSlug}/onboarding-success`
  //     : "/organization-account-setup",
  //   { replace: true }
  // );

    // createSession(response);
  };

  const userSignup = async (payload: SignupPayload) => {
    try {
      const { response } = await userSignupMutation.mutateAsync(payload);

       if (!response.status) {
      showToast.error(response.message ?? "Something went wrong. Please try again.");
      return;
    }
      dispatch(
        setPendingVerification({
          appUserUuid: response.appUserUuid,
          email: payload.email,
          provider: "email",
        }),
      );
      // dispatch(setShowWelcome());

       navigate("/organization-account-setup", { replace: true });
    } catch (error) {
      // error toast already handled in userSignupApi
    }
  };

  const verifyOtp = async (payload: { email: string; otp: string }) => {
    try {
      const response = await verifyOtpMutation.mutateAsync(payload);

      if (!response.status) {
        // showToast.error(response.message ?? "Invalid OTP. Please try again.");
        return false
      }

      createSession(response);
      dispatch(clearPendingVerification());
      dispatch(setShowWelcome());
      // navigate("/onboarding-success", { replace: true });
    } catch (error) {
      showToast.error("Invalid OTP. Please try again.");
    }
  };

  const resendOtp = async (email: string) => {
    try {
      const response = await resendOtpMutation.mutateAsync({ email });
      if (response.status) {
        showToast.success("OTP resent successfully. Please check your email.");
      } else {
        showToast.error(response.message ?? "Failed to resend OTP.");
      }
    } catch (error) {
      showToast.error("Failed to resend OTP. Please try again.");
    }
  };
  const startInviteSignupWithGoogle = async (code: string) => {
    const { response } = await inviteSignupMutation.mutateAsync(code);

    // Store minimal identity temporarily
    sessionStorage.setItem("invite_email", response.email);

    if (!response.status) {
      navigate("/invite-already-accepted", { replace: true });
    } else {
      navigate("/accept-invite" + window.location.search, {
        replace: true,
      });
    }
  };

  const joinInvitedUser = async (
    userKey: string,
    payload: InvitedSignupPayload,
  ) => {
    try {
      await joinInvitedUserMutation.mutateAsync({
        user_key: userKey,
        payload,
      });

      showToast.success("Account created successfully");
      navigate("/join-invited-user", { replace: true });
    } catch (error: unknown) {
      const message =
        error instanceof Error
          ? error.message
          : "Failed to create account. Please try again.";

      showToast.error(message);
    }
  };

  const completeInviteAcceptance = async () => {
    const inviteEmail = sessionStorage.getItem("invite_email");
    const inviteToken = sessionStorage.getItem("invite_token");

    if (!inviteEmail || !inviteToken) {
      throw new Error("Invite session expired or invalid");
    }

    const { response } = await acceptInviteMutation.mutateAsync({
      inviteEmail,
      inviteToken,
    });

    sessionStorage.removeItem("invite_email");

    createSession(response);
  };

  const forgotPassword = async (email: string) => {
  try {
    const response = await forgotPasswordMutation.mutateAsync(email);
    if (response.status) {
      showToast.success(response.message);
    } else {
      showToast.error(response.message ?? 'Something went wrong.');
    }
  } catch (error) {
    showToast.error('Failed to send reset link. Please try again.');
  }
};

const resetPassword = async (resetKey: string, password: string) => {
  try {
    const response = await resetPasswordMutation.mutateAsync({ resetKey, password });
    if (response.status) {
      showToast.success('Password reset successfully.');
      navigate('/login', { replace: true });
    } else {
      showToast.error(response.message ?? 'Something went wrong.');
    }
  } catch (error) {
    showToast.error('Failed to reset password. Please try again.');
  }                           
};


  const logout = async () => {
  try {
    await persistor.purge();
    
    // Preserve view preferences while clearing session data
    const keysToPreserve = Object.keys(localStorage).filter(key => 
      key.startsWith('pmo_hide_completed_') || key === 'pmo_sidebar_collapsed'
    );
    
    const preservedValues: Record<string, string> = {};
    keysToPreserve.forEach(key => {
      const val = localStorage.getItem(key);
      if (val) preservedValues[key] = val;
    });

    localStorage.clear();
    sessionStorage.clear();

    // Restore preserved preferences
    Object.entries(preservedValues).forEach(([key, val]) => {
      localStorage.setItem(key, val);
    });
  } finally {
    window.location.replace("/login");
  }
};
  return {
    loginWithGoogle,
    startInviteSignupWithGoogle,
    completeInviteAcceptance,
    joinInvitedUser,
    userLogin,
    userSignup,
    verifyOtp,
    resendOtp,
    forgotPassword,
    resetPassword,
    logout,
    isLoading:
      googleLoginMutation.isPending ||
      inviteSignupMutation.isPending ||
      acceptInviteMutation.isPending ||
      joinInvitedUserMutation.isPending ||
      userLoginMutation.isPending ||
      userSignupMutation.isPending ||
      verifyOtpMutation.isPending ||
      resendOtpMutation.isPending,
  };
};
